export type DeterminantCodeCategory = {
  id: string
  description: string
}

export const determinantCodeCategoryFromCode = (code: string): DeterminantCodeCategory | undefined => {
  return determinantCodeCategories.find(determinantCodeCategory => determinantCodeCategory.id === code)
}

export const determinantCodeCategoryIDs = () => determinantCodeCategories.map(category => category.id)

export const defaultDeterminantCodeForCategoryWithCode = (code: string) => {
  const category = determinantCodeCategoryFromCode(code)
  if (!category) {
    return ''
  } else if (category.id == 'SCA') {
    return 'SCA'
  } else {
    return `${category.id}XXX`
  }
}

export const determinantCodeCategoryDescription = (code: string) => {
  return determinantCodeCategoryFromCode(code)?.description ?? ''
}

const determinantCodeCategories: DeterminantCodeCategory[] = [
  { id: 'SCA', description: 'Generic Sudden Cardiac Arrest' },
  { id: '01', description: 'Abdominal Pain/Problem' },
  { id: '02', description: 'Allergic Reaction' },
  { id: '03', description: 'Animal Bite/Attack' },
  { id: '04', description: 'Assault' },
  { id: '05', description: 'Back Pain' },
  { id: '06', description: 'Breathing Problem' },
  { id: '07', description: 'Burn/Explosion' },
  { id: '08', description: 'CO/Inhalation/HAZMAT/CBRN' },
  { id: '09', description: 'Cardiac/Respiratory Arrest' },
  { id: '10', description: 'Chest Pain' },
  { id: '11', description: 'Choking' },
  { id: '12', description: 'Convulsion/Seizure' },
  { id: '13', description: 'Diabetic Problem' },
  { id: '14', description: 'Drowning/Water Accident' },
  { id: '15', description: 'Electrocution/Lightning' },
  { id: '16', description: 'Eye Problem/Injury' },
  { id: '17', description: 'Fall' },
  { id: '18', description: 'Headache' },
  { id: '19', description: 'Heart Problem' },
  { id: '20', description: 'Exposure' },
  { id: '21', description: 'Hemorrhage/Laceration' },
  { id: '22', description: 'Inaccessible/Entrapment' },
  { id: '23', description: 'Overdose/Poisoning' },
  { id: '24', description: 'Pregnancy Emergency' },
  { id: '25', description: 'Psychiatric Emergency' },
  { id: '26', description: 'Sick Person' },
  { id: '27', description: 'Penetrating Trauma' },
  { id: '28', description: 'Stroke' },
  { id: '29', description: 'Traffic Collision' },
  { id: '30', description: 'Traumatic Injury' },
  { id: '31', description: 'Unconscious/Fainting' },
  { id: '32', description: 'Unknown Medical Problem' },
  { id: '33', description: 'Transfer' },
  { id: '34', description: 'Automatic Crash Notification' },
  { id: '36', description: 'Pandemic/Epidemic/Outbreak' },
  { id: '37', description: 'Interfacility Transfer' },
  { id: '45', description: 'Transport' },
  { id: '46', description: 'Interfacility Transfer' },
  { id: '47', description: 'Mental Health Transfer' },
  { id: '49', description: 'Air Interfacility Transfer' },
  { id: '39', description: 'Active Assailant' },
  { id: '48', description: 'Air EMS/Scene Transfer' }
]
